// @ts-ignore This file generated by Emscripten
import { useEffect, useState } from "react";
import LinTalker from "./lintalker";

const SAMPLE_RATE = 22050;

interface LinTalkerModule {
  _wt_init: () => number;
  _wt_set_voice: (index: number) => number;
  _wt_speak: (ptr: number) => number;
  _wt_get_buffer: () => number;
  _wt_get_buffer_len: () => number;
  _wt_close: () => void;
  _malloc: (size: number) => number;
  _free: (ptr: number) => void;
  HEAPU8: Uint8Array;
  HEAP16: Int16Array;
}

class LinTalkerSynth {
  private _Module: LinTalkerModule;

  constructor(Module: LinTalkerModule) {
    this._Module = Module;
    const err = Module._wt_init();
    if (err !== 0) throw new Error("LinTalker engine init failed: " + err);
  }

  setVoice(index: number) {
    this._Module._wt_set_voice(index);
  }

  private toBytes(n: number) {
    return [0xff & n, 0xff & (n >> 8), 0xff & (n >> 16), 0xff & (n >> 24)];
  }

  synthesize(text: string): Uint8Array<ArrayBuffer> {
    const encoded = new TextEncoder().encode(text);
    const ptr = this._Module._malloc(encoded.length + 1);
    this._Module.HEAPU8.set(encoded, ptr);
    this._Module.HEAPU8[ptr + encoded.length] = 0;

    const err = this._Module._wt_speak(ptr);
    this._Module._free(ptr);

    if (err !== 0) throw new Error("Synthesis error: " + err);

    const len = this._Module._wt_get_buffer_len();
    const bufPtr = this._Module._wt_get_buffer();

    if (len <= 0 || bufPtr === 0) throw new Error("No audio produced");

    const samples = new Int16Array(this._Module.HEAP16.buffer, bufPtr, len);
    const pcm = new Uint8Array(samples.buffer, samples.byteOffset, samples.byteLength);
    const wavLen = 44 + pcm.length;

    // prettier-ignore
    const header = [
      0x52, 0x49, 0x46, 0x46,                   // RIFF
      ...this.toBytes(wavLen - 8),               // file size - 8
      0x57, 0x41, 0x56, 0x45,                   // WAVE
      0x66, 0x6d, 0x74, 0x20,                   // fmt
      0x10, 0x00, 0x00, 0x00,                   // fmt chunk size
      0x01, 0x00, 0x01, 0x00,                   // PCM, Mono
      ...this.toBytes(SAMPLE_RATE),             // sample rate
      ...this.toBytes(SAMPLE_RATE * 2),         // byte rate
      0x02, 0x00, 0x10, 0x00,                   // block align, bits per sample
      0x64, 0x61, 0x74, 0x61,                   // data
      ...this.toBytes(pcm.length),              // data chunk size
    ];

    return new Uint8Array([...header, ...pcm]);
  }

  close() {
    this._Module._wt_close();
  }
}

const useLintalker = () => {
  const [lintalker, setLintalker] = useState<LinTalkerSynth | null>(null);

  useEffect(() => {
    const init = async () => {
      const Module = await LinTalker();
      const synth = new LinTalkerSynth(Module);
      setLintalker(synth);
    };

    init();
  }, []);

  return { lintalker };
};

const VOICES = [
  "Fred", "Kathy", "Princess", "Junior", "Ralph",
  "Whisper", "Zarvox", "Trinoids", "Bubbles", "Boing",
  "Bells", "Hysterical", "Deranged", "Good News", "Bad News",
  "Pipe Organ", "Cellos",
] as const;

export { LinTalkerSynth, useLintalker, VOICES };
